// @ts-nocheck

import React, { useContext, useMemo } from 'react';
import { Group, Image } from 'react-konva';

import Formatter from '../../../i18n/formatter';
import { getCurrency } from '../../../i18n/l10n';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import ScalableText from './ScalableText';

const WinningsArea = (props) => {
  const { x, y, amount, isCancelled, isLost, text } = props;
  const {
    images: { banner, badge },
    stageWidth,
    userPrefs: { showWinningsAndStake },
  } = useContext(BetshareContext);
  const currency = getCurrency();

  const showWinnings = useMemo(() => !isLost && showWinningsAndStake, [isLost, showWinningsAndStake]);

  return (
    <Group x={x} y={y}>
      {banner && (
        <Image
          image={banner}
          x={0}
          y={0}
          width={getRelativeValue(400, stageWidth)}
          height={getRelativeValue(65, stageWidth)}
        />
      )}
      {isCancelled ? (
        <Image
          image={badge}
          x={getRelativeValue(100, stageWidth)}
          y={getRelativeValue(-20, stageWidth)}
          width={getRelativeValue(200, stageWidth)}
          height={getRelativeValue(85, stageWidth)}
        />
      ) : (
        <>
          <Image
            image={badge}
            x={getRelativeValue(5, stageWidth)}
            y={getRelativeValue(-58, stageWidth)}
            width={getRelativeValue(140, stageWidth)}
            height={getRelativeValue(119, stageWidth)}
          />
          {showWinnings && (
            <ScalableText
              text={Formatter.formatNumber(amount, currency)}
              fontSize={getRelativeValue(50, stageWidth)}
              lineHeight={1.2}
              fontFamily="BettingPoliticaExtraBold, sans-serif"
              x={getRelativeValue(165, stageWidth)}
              y={getRelativeValue(10, stageWidth)}
              width={getRelativeValue(225, stageWidth)}
              height={getRelativeValue(30, stageWidth)}
              align="left"
              fill="#fff"
              verticalAlign="middle"
              shadowColor="rgba(0,0,0,0.7)"
              shadowOffsetX={getRelativeValue(2, stageWidth)}
              shadowOffsetY={getRelativeValue(2, stageWidth)}
            />
          )}
          {text && (
            <ScalableText
              text={text.toUpperCase()}
              fontSize={getRelativeValue(20, stageWidth)}
              lineHeight={1.2}
              letterSpacing={1.5}
              fontFamily="BettingPoliticaExtraBold, sans-serif"
              x={getRelativeValue(165, stageWidth)}
              y={getRelativeValue(showWinnings ? 40 : 0, stageWidth)}
              width={getRelativeValue(225, stageWidth)}
              height={getRelativeValue(showWinnings ? 20 : 65, stageWidth)}
              align="left"
              fill="#fff"
              shadowColor="rgba(0,0,0,0.7)"
              shadowOffsetX={getRelativeValue(1, stageWidth)}
              shadowOffsetY={getRelativeValue(1, stageWidth)}
              verticalAlign="middle"
            />
          )}
        </>
      )}
    </Group>
  );
};

export default WinningsArea;
